// ============================================================================
// This file is COSC 2026 PROJECT SPECIFIC
// ============================================================================

// Registration Member Types
const initMemberTypes = () => {
  const countrySelect = document.getElementById("user_country");
  const memberTypeSelect = document.getElementById("user_member_type_id");
  const studentDocWrapper = document.getElementById(
    "student_document_upload_wrapper",
  );
  const studentDocInput = document.getElementById(
    "user_student_document_upload",
  );

  if (!countrySelect || !memberTypeSelect) return;

  // Skip initialization if member type field is disabled (editing mode)
  if (memberTypeSelect.disabled) return;

  const memberTypes = JSON.parse(memberTypeSelect.dataset.memberTypes || "{}");

const toggleStudentDoc = () => {
    if (!studentDocWrapper || !studentDocInput) return;
    const selectedValue = memberTypeSelect.value;
    const isLocalStudent = selectedValue === "34";

    if (isLocalStudent) {
      studentDocWrapper.classList.remove("hidden");
      studentDocInput.required = true;
    } else {
      studentDocWrapper.classList.add("hidden");
      studentDocInput.required = false;
      studentDocInput.value = "";
    }
  };

  function updateMemberTypeOptions() {
    const selectedCountryCode = countrySelect.value;

    // Clear existing options
    memberTypeSelect.innerHTML = '<option value="">- Select -</option>';

    if (!selectedCountryCode) {
      memberTypeSelect.disabled = true;
      toggleStudentDoc();
      return;
    }

    // Filter member types based on country rules
    Object.entries(memberTypes).forEach(([memberTypeName, memberTypeData]) => {
      const { id, country_rule, countries = [] } = memberTypeData;
      let shouldShow = false;

      switch (country_rule) {
        case "all_countries":
          shouldShow = true;
          break;
        case "specific_countries":
          shouldShow = countries.includes(selectedCountryCode);
          break;
        case "exclude_countries":
          shouldShow = !countries.includes(selectedCountryCode);
          break;
      }

      if (shouldShow) {
        const option = document.createElement("option");
        option.value = id;
        option.textContent = memberTypeName;
        memberTypeSelect.appendChild(option);
      }
    });

    memberTypeSelect.disabled = memberTypeSelect.options.length <= 1;
    toggleStudentDoc();
  }

  countrySelect.addEventListener("change", updateMemberTypeOptions);
  memberTypeSelect.addEventListener("change", toggleStudentDoc);
  // Initialize on page load
  updateMemberTypeOptions();
};

// Subspecialty Input
const initSubspecialties = () => {
  const countrySelect = document.getElementById("user_country");
  const subspecialtySelect = document.getElementById("user_subspecialty");
  const otherWrapper = document.getElementById("subspecialty_other_wrapper");
  const otherInput = document.getElementById("user_subspecialty_other");

  if (!countrySelect || !subspecialtySelect || !otherWrapper || !otherInput)
    return;
  if (subspecialtySelect.disabled) return;

  const subspecialties = JSON.parse(
    subspecialtySelect.dataset.subspecialties || "[]",
  );

  const savedSubspecialty = subspecialtySelect.dataset.selected;
  const savedOtherValue =
    otherInput.value ||
    otherInput.getAttribute("value") ||
    otherInput.dataset.value ||
    "";

  function showOther() {
    otherWrapper.classList.remove("hidden");
    otherInput.disabled = false;
    otherInput.required = true;

    if (savedOtherValue && otherInput.value !== savedOtherValue) {
      otherInput.value = savedOtherValue;
    }
  }

  function hideOther(clear = false) {
    otherWrapper.classList.add("hidden");
    otherInput.disabled = true;
    otherInput.required = false;
    if (clear) otherInput.value = "";
  }

  function updateSubspecialtyOptions() {
    const country = countrySelect.value;

    subspecialtySelect.innerHTML = '<option value="">- Select -</option>';

    subspecialties.forEach(({ key, name, countries }) => {
      const allowed =
        countries === "all" ||
        countries === ":all" ||
        (Array.isArray(countries) && country && countries.includes(country));

      if (!allowed) return;

      const option = document.createElement("option");
      option.value = key;
      option.textContent = name;

      if (key === savedSubspecialty) option.selected = true;

      subspecialtySelect.appendChild(option);
    });

    subspecialtySelect.disabled = subspecialtySelect.options.length <= 1;

    // ✅ EDIT MODE RULE
    // Show "other" ONLY if saved subspecialty === "others"
    if (savedSubspecialty === "others") {
      showOther();
    } else {
      hideOther(false);
    }
  }

  subspecialtySelect.addEventListener("change", (e) => {
    if (e.target.value === "others") {
      showOther();
    } else {
      hideOther(true);
    }
  });

  countrySelect.addEventListener("change", updateSubspecialtyOptions);
  updateSubspecialtyOptions();
};

document.addEventListener("DOMContentLoaded", initSubspecialties);

// Initialize all custom functionality
const initCustomFieldType = () => {
  initMemberTypes();
  initSubspecialties();
};

export default initCustomFieldType;
